// src/app/redux/actions/cataloguesActions.js

export const SET_CATALOGUES_LOADING = "SET_CATALOGUES_LOADING";
export const SET_CATALOGUES_ERROR = "SET_CATALOGUES_ERROR";

export const FETCH_CATALOGUES_REQUEST = "FETCH_CATALOGUES_REQUEST";
export const FETCH_CATALOGUES_SUCCESS = "FETCH_CATALOGUES_SUCCESS";
export const FETCH_CATALOGUES_FAIL = "FETCH_CATALOGUES_FAIL";

export const CREATE_CATALOGUE_REQUEST = "CREATE_CATALOGUE_REQUEST";
export const CREATE_CATALOGUE_SUCCESS = "CREATE_CATALOGUE_SUCCESS";
export const CREATE_CATALOGUE_FAIL = "CREATE_CATALOGUE_FAIL";

export const UPDATE_CATALOGUE_REQUEST = "UPDATE_CATALOGUE_REQUEST";
export const UPDATE_CATALOGUE_SUCCESS = "UPDATE_CATALOGUE_SUCCESS";
export const UPDATE_CATALOGUE_FAIL = "UPDATE_CATALOGUE_FAIL";

export const DELETE_CATALOGUE_REQUEST = "DELETE_CATALOGUE_REQUEST";
export const DELETE_CATALOGUE_SUCCESS = "DELETE_CATALOGUE_SUCCESS";
export const DELETE_CATALOGUE_FAIL = "DELETE_CATALOGUE_FAIL";

export const setCataloguesLoading = (v) => ({ type: SET_CATALOGUES_LOADING, payload: v });
export const setCataloguesError = (msg) => ({ type: SET_CATALOGUES_ERROR, payload: msg });

export const fetchCataloguesRequest = () => ({ type: FETCH_CATALOGUES_REQUEST });
export const fetchCataloguesSuccess = (data) => ({ type: FETCH_CATALOGUES_SUCCESS, payload: data });
export const fetchCataloguesFail = (err) => ({ type: FETCH_CATALOGUES_FAIL, payload: err });

export const createCatalogueRequest = (payload) => ({ type: CREATE_CATALOGUE_REQUEST, payload });
export const createCatalogueSuccess = (data) => ({ type: CREATE_CATALOGUE_SUCCESS, payload: data });
export const createCatalogueFail = (err) => ({ type: CREATE_CATALOGUE_FAIL, payload: err });

export const updateCatalogueRequest = (id, payload) => ({
    type: UPDATE_CATALOGUE_REQUEST,
    payload: { id, payload },
});
export const updateCatalogueSuccess = (data) => ({ type: UPDATE_CATALOGUE_SUCCESS, payload: data });
export const updateCatalogueFail = (err) => ({ type: UPDATE_CATALOGUE_FAIL, payload: err });

export const deleteCatalogueRequest = (id) => ({ type: DELETE_CATALOGUE_REQUEST, payload: { id } });
export const deleteCatalogueSuccess = (id) => ({ type: DELETE_CATALOGUE_SUCCESS, payload: id });
export const deleteCatalogueFail = (err) => ({ type: DELETE_CATALOGUE_FAIL, payload: err });
